/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Observable } from 'rxjs';
import { DataSource } from 'angular2-smart-table';
import { Settings } from '../common/settings';
// import { Address } from './address';
import { UserRole } from './user-role';
import { EntityConfigTemplate } from '../common/entity-config.interface';

export interface User {
  id?: number;
  documentId?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  username?: string;
  name?: string;
  // age: number;
  picture?: string;
  // address: Address;
  settings?: Settings;
  provider?: string;
  password?: string;
  confirmed?: boolean;
  blocked?: boolean;
  role?: UserRole;
  status?: string;
  departments?: any[];
  password_expired?: boolean;
  created_attn_sheets?: any[];
  requested_cfrs?: any[]
  approved_cfr?: any[];
  rejected_cfr?: any[];
  permissions?: string[];
}

export const UserConfig: EntityConfigTemplate = {
  meta: { entityName: 'user', entityPluralName: 'users', titleField: 'name', searchFields: ['firstName', 'lastName', 'username', 'email'], view: false },
  firstName: { title: 'First Name' },
  lastName: { title: 'Last Name' },
  email: { title: 'Email' },
  username: { title: 'Username' },
  name: { title: 'Full Name', valuePrep: (_cell_, row) => `${row?.firstName ?? ''} ${row?.lastName ?? ''}` },
  // picture: { title: 'Picture', type: 'file' },
  role: { isForeignKey: true, type:'relation', entityName:'role', title:'Role', valuePrep: (_cell_, row) => `${row?.role?.name ?? ''}` },
  status: { title: 'Status' },
  createdAt: { view:{ list:false } },
  updatedAt: { valuePrep: (_cell_, row) => row?.updatedAt ? new Date(row.updatedAt).toLocaleDateString() : '' },
};


export abstract class UserData {
  abstract get gridDataSource(): DataSource;
  abstract getCurrentUser(): Observable<User>;
  abstract listAll(filters?: { [field: string]: any }): Observable<User[]>;
  abstract list(pageNumber: number, pageSize: number): Observable<User[]>;
  abstract get(id: number): Observable<User>;
  abstract update(user: any): Observable<User>;
  abstract updateCurrent(user: User): Observable<User>;
  abstract changeCurrentPassword(newPasswords: any): Observable<any>;
  abstract create(user: any): Observable<User>;
  abstract delete(id: number): Observable<boolean>;
}
